import { Component } from "@angular/core";

@Component({
	selector: "slick-context-menu-item",
	template: `<div class="dropdown-item"><ng-content></ng-content></div>`
})
export class SlickContextMenuItemComponent {}